(function () {
  'use strict';

  var SI_CONFIGS = {
    enzimas:     { tabClass: 'si-active-green',  iconClass: 'si-icon-green'  },
    probioticos: { tabClass: 'si-active-salmon', iconClass: 'si-icon-salmon' },
    hierbas:     { tabClass: 'si-active-lav',    iconClass: 'si-icon-lav'    }
  };

  function sanaIngShow(id) {
    document.querySelectorAll('.sana-ing-seg').forEach(function (t) {
      t.className = 'sana-ing-seg';
      var key = t.getAttribute('data-blend');
      var icon = t.querySelector('.sana-ing-tab-icon');
      if (icon && SI_CONFIGS[key]) {
        icon.className = 'sana-ing-tab-icon ' + SI_CONFIGS[key].iconClass;
      }
    });
    document.querySelectorAll('.sana-ing-panel').forEach(function (p) {
      p.classList.remove('si-active');
    });
    var activeTab = document.querySelector('.sana-ing-seg[data-blend="' + id + '"]');
    if (activeTab && SI_CONFIGS[id]) {
      activeTab.classList.add(SI_CONFIGS[id].tabClass);
    }
    var activePanel = document.getElementById('si-panel-' + id);
    if (activePanel) activePanel.classList.add('si-active');
  }

  window.sanaIngShow = sanaIngShow;

  document.addEventListener('DOMContentLoaded', function () {
    var firstActive = document.querySelector('.sana-ing-panel.si-active');
    if (!firstActive) sanaIngShow('enzimas');
  });
})();